export default "__VITE_ASSET__DqALlM2R__"